import React from "react";
import { Region } from "../../common/layout/region";
import LikeStatus from "./likeStatus";
import InternshipHistory from "./internshipHistory";
// import CurrentYearStat from "./currentYearStat";
import CurrentYearStat from "./currentYearStat_v2";
import Calendar from "./calendar";
import { useTranslation } from "react-i18next";
import { getCurrentAcadimicYear } from "../../../utils/functions/javaScriptHelper";
import "./style.css";

const Dashboard = () => {
	const { t } = useTranslation();
	return (
		<Region>
			<div className="pageHeader_row">
				<div className="determineIntrn_container_card_title_container">
					<div className="determineIntrn_container_card_title_primary">
						{t("left_nav_bottom_optiion_internship_dashboard")}
						{` ${getCurrentAcadimicYear()}`}
					</div>
				</div>
			</div>
			<div className="internship_dashboard_pageContainer">
				<div className="area_calendar">
					<Calendar />
				</div>
				<div className="area_candidateLike">
					<LikeStatus />
				</div>
				<div className="area_internshipHistory">
					<InternshipHistory />
				</div>
				<div className="area_currentYearStat">
					<CurrentYearStat />
				</div>
			</div>
		</Region>
	);
};

export default Dashboard;
